(() => {
  const bundleSelector = '.ng-product-bundle .cbb-frequently-bought-container';
  const productsSelector = '.cbb-frequently-bought-products';
  const productSelector = '.cbb-frequently-bought-product';
  const selectorListSelector = '.cbb-frequently-bought-selector-list';
  const buttonSelector = '.cbb-frequently-bought-add-button';
  const titleSelector = '.cbb-frequently-bought-title';
  const totalTextSelector = '.cbb-frequently-bought-total-price-text';
  const currentItemLabelSelector = '.cbb-frequently-bought-this-item-label';
  const variantSelector = '.cbb-recommendations-variant-select';
  const checkboxSelector = '.cbb-frequently-bought-selector-input';
  const excludeValue = '__ng_bundle_excluded__';
  let pending = false;

  const updateModuleCopy = (container) => {
    const title = container.querySelector(titleSelector);
    if (title) {
      const heading = title.querySelector('.ng-product-bundle-heading');
      if (heading) {
        if (heading.textContent !== 'BUNDLE & SAVE: BUILD YOUR FLAVOUR SET') {
          heading.textContent = 'BUNDLE & SAVE: BUILD YOUR FLAVOUR SET';
        }
        const eyebrow = title.querySelector('.ng-product-bundle-eyebrow');
        if (eyebrow) eyebrow.remove();
      } else {
        const newHeading = document.createElement('span');
        newHeading.className = 'ng-product-bundle-heading';
        newHeading.textContent = 'BUNDLE & SAVE: BUILD YOUR FLAVOUR SET';
        title.replaceChildren(newHeading);
        title.classList.add('ng-section-title');
      }
    }

    container.querySelectorAll(currentItemLabelSelector).forEach((label) => {
      if (label.textContent !== 'Current item · ') label.textContent = 'Current item · ';
    });

    const selectedCount = container.querySelectorAll(`${checkboxSelector}:checked`).length;
    const totalText = container.querySelector(totalTextSelector);
    if (totalText) {
      const summary = `${selectedCount} ${selectedCount === 1 ? 'item' : 'items'} ·`;
      if (totalText.textContent !== summary) totalText.textContent = summary;
    }

    const button = container.querySelector(buttonSelector);
    if (!button) return;

    const label = button.querySelector('.translatable') || button;
    if (label.textContent.trim() !== 'Add set to trolley') {
      label.textContent = 'Add set to trolley';
    }
    button.setAttribute('aria-label', 'Add set to trolley');
  };

  const enhanceProductCard = (card, container) => {
    const checkbox = card.querySelector(checkboxSelector);
    const select = card.querySelector(variantSelector);
    if (!checkbox || !select) return;

    let excludeOption = Array.from(select.options).find((option) => option.value === excludeValue);
    if (!excludeOption) {
      excludeOption = new Option("Don't add", excludeValue);
      select.insertBefore(excludeOption, select.firstElementChild);
    } else if (excludeOption.textContent !== "Don't add") {
      excludeOption.textContent = "Don't add";
    }

    const syncExcludedState = () => {
      card.classList.toggle('ng-product-bundle-card--excluded', !checkbox.checked);
      if (!checkbox.checked) select.value = excludeValue;
      requestAnimationFrame(() => updateModuleCopy(container));
    };

    if (select.dataset.ngBundleExcludeReady !== 'true') {
      select.dataset.ngBundleExcludeReady = 'true';
      select.addEventListener(
        'change',
        (event) => {
          const shouldInclude = select.value !== excludeValue;

          if (checkbox.checked !== shouldInclude) checkbox.click();
          card.classList.toggle('ng-product-bundle-card--excluded', !shouldInclude);

          if (!shouldInclude) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
      checkbox.addEventListener('change', syncExcludedState);
    }

    syncExcludedState();
  };

  const integrateProductCards = (container) => {
    const products = container.querySelector(productsSelector);
    const selectorList = container.querySelector(selectorListSelector);
    if (!products) {
      updateModuleCopy(container);
      return;
    }

    const productCards = Array.from(products.children).filter((item) => item.classList.contains('cbb-frequently-bought-product'));
    const selectorItems = selectorList ? Array.from(selectorList.children).filter((item) => item.matches('li')) : [];
    if (!productCards.length) {
      updateModuleCopy(container);
      return;
    }

    products.classList.add('ng-product-bundle-cards');
    const count = productCards.length;
    products.dataset.itemCount = String(count);
    container.dataset.bundleCount = String(count);
    const plusSvg =
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 1V11M1 6H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    productCards.forEach((card, index) => {
      const selectorItem = selectorItems[index];
      card.classList.add('ng-product-bundle-card');
      if (selectorItem && selectorItem.parentElement !== card) card.appendChild(selectorItem);
      enhanceProductCard(card, container);

      // Remove any duplicate or internal plus icon inside the card
      card.querySelectorAll('.cbb-frequently-bought-plus-icon').forEach((el) => el.remove());

      if (index < productCards.length - 1) {
        let plusIcon = card.nextElementSibling;
        if (!plusIcon || !plusIcon.classList.contains('cbb-frequently-bought-plus-icon')) {
          plusIcon = document.createElement('div');
          plusIcon.className = 'cbb-frequently-bought-plus-icon';
          card.after(plusIcon);
        }
        if (!plusIcon.querySelector('svg')) {
          plusIcon.innerHTML = plusSvg;
        }
        let extra = plusIcon.nextElementSibling;
        while (extra && extra.classList.contains('cbb-frequently-bought-plus-icon')) {
          const toRemove = extra;
          extra = extra.nextElementSibling;
          toRemove.remove();
        }
      }
    });

    const lastCard = productCards[productCards.length - 1];
    if (lastCard) {
      let next = lastCard.nextElementSibling;
      while (next && next.classList.contains('cbb-frequently-bought-plus-icon')) {
        const toRemove = next;
        next = next.nextElementSibling;
        toRemove.remove();
      }
    }

    if (selectorList) selectorList.hidden = selectorList.children.length === 0;
    updateModuleCopy(container);
  };

  const refresh = () => {
    pending = false;
    document.querySelectorAll(bundleSelector).forEach(integrateProductCards);
  };

  const scheduleRefresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  };

  const start = () => {
    scheduleRefresh();
    new MutationObserver(scheduleRefresh).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
